import { StruggleCompetency, StruggleData } from '@/models/groups/report';
import { Vue, Component, Prop } from 'vue-property-decorator';
import * as d3 from 'd3';
import { generateNodeStream } from 'jszip';

@Component({
    name: 'struggling-competency-card',
})

export default class StrugglingCompetencyCard extends Vue {

    // ------------------------------------------------------
    // Properties

    @Prop()
    private strugglingCompetencies!: StruggleData[];

    @Prop()
    private learningReportData: any;

    private showMore: boolean = false;

    private get competencyCount() {
        let count: number = 0;
        this.strugglingCompetencies.forEach((struggle: any) => {
            if (struggle.competencies.length > 0) {
                count++;
            }
        });
        return count;
    }

    // ----------------------------------------------------
    // Methods

    private created() {
        this.strugglingCompetencies.sort((a: any, b: any) => a.gradeSeq - b.gradeSeq);
    }

    private iconLoader(competencies: StruggleCompetency[], count: any) {
        const userCount = count <= 7 ? count : 7;
        return userCount ? new Array(userCount).fill({}) : [];
    }
}
